import { Box, Divider, Typography } from '@mui/material';

export default function Progress({
  steps,
  isError,
  isApproved,
  isWrapped
}: {
  steps: number;
  isError?: boolean;
  isApproved?: boolean;
  isWrapped?: boolean;
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
      }}
    >
      <Box
        sx={{
          backgroundColor: isError
            ? 'rgba(255, 0, 0, 0.2)'
            : isApproved && steps === 1
              ? 'rgba(4, 255, 218, 1)'
              : isWrapped
                ? 'rgba(4, 255, 218, 1)'
                : 'white',
          borderRadius: '50%',
          width: 32,
          height: 32,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Typography sx={{ color: 'black' }}>
          {isApproved && steps === 1 ? 1 : isApproved ? 2 : isWrapped ? 3 : 1}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          gap: 1
        }}
      >
        <Divider
          sx={{
            width: '20%',
            borderColor: isError
              ? 'rgba(255, 0, 0, 0.2)'
              : isApproved
                ? 'rgba(4, 255, 218, 1)'
                : 'rgba(255, 255, 255, 0.37)'
          }}
        />
        {steps > 1 && (
          <Divider
            sx={{
              width: '20%',
              borderColor: isError
                ? 'rgba(255, 0, 0, 0.2)'
                : isWrapped
                  ? 'rgba(4, 255, 218, 1)'
                  : 'rgba(255, 255, 255, 0.37)'
            }}
          />
        )}
        {steps > 2 && (
          <Divider
            sx={{
              width: '20%',
              borderColor: isError ? 'rgba(255, 0, 0, 0.2)' : 'rgba(255, 255, 255, 0.37)'
            }}
          />
        )}
      </Box>
    </Box>
  );
}
